import gql from "graphql-tag"
import partialUser from "@irati/identity/services/fragments/PartialUser"
import RecognitionFeedReaction from "../../services/fragments/RecognitionFeedReaction"
import GroupCelebrationMessage from "./GroupCelebrationMessage"
import CommentFragment from "./Comment"
import CelebrationTag from "./CelebrationTag"

const fragment = gql`
  fragment ScheduledGroupCelebration on GroupCelebration {
    uuid
    businessId
    author {
      ...partialUser
    }
    receiver {
      ...partialUser
    }
    greeting {
      ...CelebrationTag
    }
    messages {
      ...GroupCelebrationMessage
    }
    comments {
      results {
        ...Comment
      }
    }
    reactions {
      results {
        ...reactionFields
      }
    }
    moderated
    status
    source
    walletTransferIds
    collaborators {
      ...partialUser
    }
    budget {
      categoryId
      useUnassigned
    }
    visibility
    rewardAmount
    scheduledAt
    when
    originalTimezone
    scheduledEventId
  }
  ${partialUser}
  ${CommentFragment}
  ${CelebrationTag}
  ${GroupCelebrationMessage}
  ${RecognitionFeedReaction}
`

export default fragment
